import React, { useState } from 'react';

const services = [
  {
    icone: '🗄️',
    titre: 'Base de Données',
    couleur: '#1A1AE6',
    resume: 'Conception et optimisation de systèmes de données robustes et sécurisés.',
    description: 'Nous concevons, optimisons et administrons vos bases de données relationnelles et non-relationnelles. De l\'architecture initiale à la maintenance, nous garantissons performance, sécurité et haute disponibilité de vos données.',
    points: [
      'Conception et modélisation de bases de données',
      'Optimisation des performances et des requêtes',
      'Migration et intégration de données',
      'Sauvegarde, sécurité et haute disponibilité',
      'Administration et maintenance continue',
    ],
  },
  {
    icone: '🌐',
    titre: 'Développement Web & Mobile',
    couleur: '#6B21E8',
    resume: 'Sites vitrines, web apps, applications Android et iOS sur mesure.',
    description: 'Du site vitrine professionnel à l\'application mobile complexe, nous développons des solutions digitales modernes, performantes et adaptées à vos besoins spécifiques et à votre budget.',
    points: [
      'Sites vitrines et institutionnels',
      'Applications web (SaaS, e-commerce, portails)',
      'Applications mobiles Android & iOS',
      'Interfaces d\'administration (dashboards)',
      'Intégration d\'APIs et services tiers',
    ],
  },
  {
    icone: '🔒',
    titre: 'Cybersécurité',
    couleur: '#10B981',
    resume: 'Audit, conseil et protection de vos systèmes et données sensibles.',
    description: 'Nous accompagnons les organisations dans la sécurisation de leur infrastructure numérique. Audit de vulnérabilités, mise en place de politiques de sécurité et formation de vos équipes pour protéger vos actifs critiques.',
    points: [
      'Audit et test de vulnérabilités',
      'Mise en place de politiques de sécurité',
      'Protection des données sensibles',
      'Surveillance et détection des menaces',
      'Formation et sensibilisation des équipes',
    ],
  },
  {
    icone: '🔌',
    titre: 'Réseaux & Infrastructure',
    couleur: '#0EA5E9',
    resume: 'Installation, configuration et maintenance de vos infrastructures réseau.',
    description: 'Nous concevons et déployons des infrastructures réseau fiables et performantes pour votre organisation. Du câblage structuré aux réseaux sans fil, nous assurons la connectivité et la stabilité de vos systèmes.',
    points: [
      'Installation et câblage réseau (LAN/WAN)',
      'Configuration de routeurs et switches',
      'Mise en place de réseaux WiFi sécurisés',
      'VPN et accès distant sécurisé',
      'Maintenance et supervision réseau',
    ],
  },
  {
    icone: '💡',
    titre: 'Consultation IT',
    couleur: '#F5C500',
    resume: 'Conseils stratégiques pour moderniser et améliorer vos systèmes existants.',
    description: 'Nos experts analysent vos systèmes existants et vous proposent des stratégies concrètes pour améliorer vos opérations, réduire vos coûts et moderniser votre infrastructure technologique.',
    points: [
      'Audit de l\'existant et recommandations',
      'Stratégie de transformation numérique',
      'Amélioration des processus métier',
      'Accompagnement au changement',
      'Formation et transfert de compétences',
    ],
  },

  {
  icone: '⚡',
  titre: 'Installations Électriques',
  couleur: '#F5C500',
  resume: 'Étude, dimensionnement, installation et maintenance de systèmes électriques fiables',
  description: 'EFE Systems réalise des installations électriques professionnelles pour entreprises, institutions et organisations. De la conception au déploiement, nous garantissons sécurité et conformité aux normes.',
  points: [
    
    'Étude et dimensionnement des installations électriques',
    'Conception et installation de systèmes électriques',
    'Tableaux électriques et réseaux de distribution',
    'Éclairage intérieur, extérieur et industriel',
    'Solutions solaires et systèmes d’énergie',
    'Maintenance préventive et dépannage électrique',
  ],
},

];

function Services() {
  const [actif, setActif] = useState(null);

  return (
<section id="services" className="py-24 px-6" style={{ background: '#cdcdcf' }}>
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full text-sm mb-4"
            style={{ background: 'rgba(26,26,230,0.08)', border: '1px solid rgba(26,26,230,0.2)', color: '#1A1AE6' }}>
            Nos Expertises
          </div>
          <h2 className="text-4xl font-extrabold mb-4" style={{ color: '#0F0F2D' }}>
            Ce que nous faisons
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
          Des solutions numériques et électriques innovantes, fiables et adaptées aux réalités de votre organisation.
          </p>
        </div>

        {/* Grille de cartes */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service, index) => (
            <div key={index}>
              <div
                onClick={() => setActif(actif === index ? null : index)}
                className="cursor-pointer rounded-2xl p-6 transition-all duration-300 bg-white"
                style={{
                  border: `1px solid ${actif === index ? service.couleur + '60' : 'rgba(0,0,0,0.06)'}`,
                  boxShadow: actif === index ? `0 0 30px ${service.couleur}15` : '0 2px 8px rgba(0,0,0,0.04)',
                }}
              >
                {/* Icône + Titre */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl"
                      style={{ background: `${service.couleur}10`, border: `1px solid ${service.couleur}25` }}>
                      {service.icone}
                    </div>
                    <h3 className="font-bold text-lg" style={{ color: '#0F0F2D' }}>
                      {service.titre}
                    </h3>
                  </div>
                  {/* Flèche */}
<div className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 flex-shrink-0"
  style={{
    background: actif === index ? service.couleur : '#1E293B',
    transform: actif === index ? 'rotate(180deg)' : 'rotate(0deg)',
  }}>
  <svg className="w-4 h-4" fill="none" stroke="white" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
</div>
                </div>

                {/* Résumé */}
                <p className="text-gray-500 text-sm leading-relaxed mb-4">
                  {service.resume}
                </p>

                {/* Ligne colorée animée */}
                <div className="h-0.5 rounded-full transition-all duration-500"
                  style={{
                    background: service.couleur,
                    width: actif === index ? '100%' : '48px'
                  }}>
                </div>

                {/* Détails dépliables */}
                {actif === index && (
                  <div className="mt-5 pt-5" style={{ borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4">
                      {service.description}
                    </p>
                    <ul className="space-y-2">
                      {service.points.map((point, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-gray-500">
                          <span className="mt-0.5 text-xs" style={{ color: service.couleur }}>✦</span>
                          {point}
                        </li>
                      ))}
                    </ul>
                    <button
                      className="mt-5 w-full py-2 rounded-xl text-sm font-semibold transition hover:opacity-90"
                      style={{ background: `${service.couleur}10`, color: service.couleur, border: `1px solid ${service.couleur}30` }}
                    >
                      Demander un devis →
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default Services;